export default __webpack_public_path__ + "static/media/nextjs.1b2b52c0.svg";